module.exports = __webpack_public_path__ + "static/media/crypto-trading-faq.56db83c3.md";


//////////////////
// WEBPACK FOOTER
// ./src/blog/crypto-trading-faq.md
// module id = 767
// module chunks = 0